{
  "hubspot": {
    "lifecycleStage": {
      "subscriber": "Subscriber",
      "lead": "Lead",
      "marketingQualifiedLead": "Marketing Qualified Lead",
      "salesQualifiedLead": "Sales Qualified Lead",
      "opportunity": "Opportunity",
      "customer": "Customer",
      "leadForLater": "Lead for Later",
      "partnerLead": "Partner Lead"
    },
    "leadStatus": {
      "new": "New",
      "open": "Open",
      "inProgress": "In Progress",
      "openDeal": "Open Deal",
      "attemptedToContact": "Attempted to Contact",
      "connected": "Connected",
      "badTiming": "Bad Timing",
      "meeting": "Meeting Scheduled",
      "qualified": "Qualified",
      "unqualified": "Unqualified",
      "firstEmail": "First Email Sent",
      "firstEmailFollowUp1": "First Email | 1st Follow-up",
      "firstEmailFollowUp2": "First Email | 2nd Follow-up",
      "appointmentScheduled": "Appointment Scheduled",
      "notSuitable": "Not Suitable",
      "noConcretization": "No Concretization"
    },
    "relationship": {
      "b2bLicense": "B2B License (for end customers)",
      "partnerLicenseWithoutSeats": "Partner License (without Seats)",
      "partnerLicenseWithSeats": "Partner License (with Seats)",
      "internationalPartnerLicenseWithSeat": "International Partner License (with Seat)",
      "internationalPartnerLicenseWithoutSeat": "International Partner License (without Seat)",
      "internationalB2bLicenseEndUser": "International B2B License (End User)",
      "externalWorkforceProductDevelopment": "External Workforce for Product Development",
      "communityCatalyst": "Community Catalyst",
      "technicalIntegrationPartner": "Technical Integration Partner"
    }
  }
}
